import React from 'react';
import ReactDOM from 'react-dom/client';
import { configure } from '@centrix/api-client';
import { App } from './App';
import './index.css';

configure({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  lmsBaseUrl: import.meta.env.VITE_LMS_BASE_URL,
  env: import.meta.env,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
